import { releaseNoteOptions as releaseNoteOptionNames } from "../../../../consts";
import { objectUtil } from "../../../../utils";

const bulletPoint = "•";

const getIsReleaseNoteEmpty = (localizations, releaseNotesType) => {
  let isEmpty = localizations.length === 1;
  const config = localizations[0]?.config;

  if (releaseNotesType === releaseNoteOptionNames.SIMPLE_LIST) {
    const { newFeaturesList, improvementsList } = config ?? {};
    isEmpty =
      isEmpty && newFeaturesList?.trim()?.length < 2 && improvementsList?.trim()?.length < 2;
  } else {
    isEmpty = isEmpty && config?.length === 1;

    if (isEmpty) {
      const { title, description, icon } = config[0];

      isEmpty = isEmpty && !title && !description && !icon;
    }
  }

  return isEmpty;
};

const getReleaseNoteErrors = (localizations, iconsData, releaseNotesType) => {
  const localisationErrorFields = [];

  if (localizations.length) {
    const isEmpty = getIsReleaseNoteEmpty(localizations, releaseNotesType);

    if (!isEmpty) {
      localizations.map((item) => {
        const { summary } = item ?? {};
        const summaryError = summary != null && summary?.length === 0;

        if (releaseNotesType === releaseNoteOptionNames.SIMPLE_LIST) {
          const { newFeaturesList, improvementsList } = item?.config ?? {};

          let newFeaturesListEmpty = !newFeaturesList || newFeaturesList?.trim()?.length < 2;
          let improvementsListEmpty = !improvementsList || improvementsList?.trim()?.length < 2;

          const simpleListError = newFeaturesListEmpty && improvementsListEmpty;

          if (simpleListError || summaryError) {
            const errorConfig = {
              language: item.title,
              summary: summaryError,
              newFeaturesList: simpleListError,
              improvementsList: simpleListError
            };
            localisationErrorFields.push(errorConfig);
          }
        } else {
          const itemErrorConfigs = [];

          item?.config?.forEach((config) => {
            const { id, title, linkText, link } = config ?? {};
            const iconConfig = iconsData?.find((el) => el.id === id);

            const { icon } = iconConfig ?? {};

            const iconError = !icon;

            const titleError = !title;

            const linkTextError = linkText != null && linkText?.length === 0;
            const linkError = link != null && link?.length === 0;

            if (iconError || titleError || linkTextError || linkError) {
              const errorConfig = {
                id,
                icon: iconError,
                title: titleError,
                linkText: linkTextError,
                link: linkError
              };

              itemErrorConfigs.push(errorConfig);
            }
          });

          if (itemErrorConfigs?.length || summaryError) {
            const errorConfig = {
              language: item.title,
              summary: summaryError,
              config: itemErrorConfigs?.length ? itemErrorConfigs : null
            };

            localisationErrorFields.push(errorConfig);
          }
        }
      });
    }
  }

  return localisationErrorFields;
};

const parseReleaseNotes = (releaseNotes) => {
  const localizations = [];
  const type = releaseNotes?.releaseNotesType;
  const media = (releaseNotes?.media ?? [])?.map((el) => {
    return { ...el, icon: el?.imageFile };
  });
  const thumbnails = (releaseNotes?.thumbnails ?? [])?.map((el) => {
    return { ...el, media: el?.imageFile };
  });

  if (type) {
    if (type === releaseNoteOptionNames.SIMPLE_LIST) {
      releaseNotes?.localizations?.forEach((item, index) => {
        const { features, improvements, language, summary } = item;

        const newFeaturesList = features
          ? `${bulletPoint} ${features?.join(`\n${bulletPoint} `)}`
          : "";
        const improvementsList = improvements
          ? `${bulletPoint} ${improvements?.join(`\n${bulletPoint} `)}`
          : "";

        localizations.push({
          id: index,
          title: language,
          summary,
          config: {
            newFeaturesList,
            improvementsList
          }
        });
      });
    } else {
      releaseNotes?.localizations?.forEach((item, index) => {
        localizations.push({
          id: index,
          summary: item?.summary,
          title: item?.language,
          config: item?.features
        });
      });
    }
  }

  return { type, localizations, media, thumbnails };
};

const formatReleaseNotes = (localizations, releaseNotesType) => {
  const formattedLocalizations = [];

  const isEmpty = getIsReleaseNoteEmpty(localizations, releaseNotesType);

  if (isEmpty) {
    return null;
  }

  if (releaseNotesType) {
    if (releaseNotesType === releaseNoteOptionNames.SIMPLE_LIST) {
      localizations?.forEach((item) => {
        const { newFeaturesList, improvementsList } = item?.config ?? {};

        const features = newFeaturesList?.replace(`${bulletPoint} `, "").split(`\n${bulletPoint} `);
        const improvements = improvementsList
          ?.replace(`${bulletPoint} `, "")
          .split(`\n${bulletPoint} `);

        const localization = {
          language: item?.title
        };

        if (item?.summary) {
          localization.summary = item?.summary;
        }

        if (features?.filter((el) => el?.length > 0)?.length) {
          localization.features = features;
        }

        if (improvements?.filter((el) => el?.length > 0)?.length) {
          localization.improvements = improvements;
        }

        formattedLocalizations.push(localization);
      });
    } else {
      localizations?.forEach((item) => {
        formattedLocalizations.push(
          objectUtil.removeEmptyFileds({
            language: item?.title,
            summary: item?.summary,
            features: item?.config?.map((el) => {
              return {
                id: el?.id,
                title: el?.title,
                description: el?.description,
                link: el?.link,
                linkText: el?.linkText
              };
            })
          })
        );
      });
    }
  }

  return formattedLocalizations;
};

const formatMediaData = (mediaData) => {
  return mediaData.map((el) => {
    return { id: el?.id, mediaExtension: el?.mediaExtension };
  });
};

export const releaseNoteUtils = {
  getIsReleaseNoteEmpty,
  getReleaseNoteErrors,
  parseReleaseNotes,
  formatReleaseNotes,
  formatMediaData
};
